import React from "react";
import {
    Input,
    Select,
    DatePicker,
    Checkbox,
    Row,
    Col,
    InputNumber,
    Divider,
    Collapse,
} from "antd";
import moment from "moment";

const { RangePicker } = DatePicker;
const { TextArea } = Input;

/**
 * Advanced filter form for booking search.
 * Бүх талбар filters object-оор удирддаг (controlled).
 */
export default function FilterForm({
    filters,
    setFilters,
    serviceTypes = [],
    services = [],
    doctors = [],
    technicians = [],
    receptions = [],
    ceItems = [],
    onSearch,
}) {
    const set = (k) => (v) => {
        const value = v && v.target ? v.target.value : v;
        setFilters((prev) => ({ ...prev, [k]: value }));
    };

    const setBool = (k) => (e) => {
        setFilters((prev) => ({ ...prev, [k]: e.target.checked ? 1 : -1 }));
    };

    const onEnter = (e) => {
        if (e.key === "Enter" && onSearch) onSearch();
    };

    // үйлчилгээний жагсаалтыг сонгосон төхөөрөмжөөр шүүх
    const filteredServices =
        filters.servicetype && filters.servicetype != -1
            ? [
                { label: "Бүгд", value: -1 },
                ...services.filter(
                    (s) => s.servicetypeid === filters.servicetype
                ),
            ]
            : services;

    const filteredCeItems =
        filters.servicetype && filters.servicetype != -1
            ? [
                { label: "Бүгд", value: -1 },
                ...ceItems.filter((c) => c.servicetypeid === filters.servicetype),
            ]
            : ceItems;

    // ── Үндсэн (хамгийн их хэрэглэгддэг) талбарууд ───────────────────────────
    const mainFields = (
        <Row gutter={[12, 12]}>
            <Col xs={24} md={12} lg={8}>
                <label className="block text-xs text-gray-500 mb-1">Зовиур</label>
                <TextArea
                    rows={1}
                    value={filters.painful}
                    onChange={set("painful")}
                    onPressEnter={onEnter}
                    placeholder="Жнь: толгой өвдөх"
                    autoSize={{ minRows: 1, maxRows: 3 }}
                />
            </Col>

            <Col xs={24} md={12} lg={8}>
                <label className="block text-xs text-gray-500 mb-1">
                    Эмчийн хариу (текст)
                </label>
                <Input
                    value={filters.response}
                    onChange={set("response")}
                    onPressEnter={onEnter}
                    placeholder="Хариу дотроос хайх"
                />
            </Col>

            <Col xs={24} md={12} lg={8}>
                <label className="block text-xs text-gray-500 mb-1">Огноо</label>
                <RangePicker
                    className="w-full"
                    value={
                        filters.startdate && filters.enddate
                            ? [moment(filters.startdate), moment(filters.enddate)]
                            : null
                    }
                    onChange={(vals) => {
                        if (!vals) {
                            setFilters((p) => ({ ...p, startdate: null, enddate: null }));
                        } else {
                            setFilters((p) => ({
                                ...p,
                                startdate: vals[0].startOf("day").toISOString(),
                                enddate: vals[1].endOf("day").toISOString(),
                            }));
                        }
                    }}
                    allowClear
                    placeholder={["Эхлэх", "Дуусах"]}
                />
            </Col>

            <Col xs={24} md={12} lg={6}>
                <label className="block text-xs text-gray-500 mb-1">Овог / Нэр</label>
                <Input
                    value={filters.customerName}
                    onChange={set("customerName")}
                    onPressEnter={onEnter}
                    placeholder="Овог эсвэл нэр"
                />
            </Col>

            <Col xs={12} md={6} lg={4}>
                <label className="block text-xs text-gray-500 mb-1">РД</label>
                <Input
                    value={filters.regno}
                    onChange={set("regno")}
                    onPressEnter={onEnter}
                    placeholder="Регистр"
                />
            </Col>

            <Col xs={12} md={6} lg={4}>
                <label className="block text-xs text-gray-500 mb-1">Утас</label>
                <Input
                    value={filters.mobile}
                    onChange={set("mobile")}
                    onPressEnter={onEnter}
                    placeholder="Утас"
                />
            </Col>

            <Col xs={24} md={12} lg={5}>
                <label className="block text-xs text-gray-500 mb-1">Төхөөрөмж</label>
                <Select
                    className="w-full"
                    value={filters.servicetype}
                    onChange={(v) =>
                        setFilters((p) => ({
                            ...p,
                            servicetype: v,
                            serviceId: -1,
                            ceitemid: -1,
                        }))
                    }
                    options={serviceTypes}
                />
            </Col>

            <Col xs={24} md={12} lg={5}>
                <label className="block text-xs text-gray-500 mb-1">Үйлчилгээ</label>
                <Select
                    className="w-full"
                    value={filters.serviceId}
                    onChange={set("serviceId")}
                    options={filteredServices}
                    showSearch
                    optionFilterProp="label"
                />
            </Col>
        </Row>
    );

    // ── Нэмэлт (нуугдсан) талбарууд ──────────────────────────────────────────
    const extraFields = (
        <>
            <Divider style={{ margin: "8px 0" }} orientation="left" plain>
                Хариуцагч
            </Divider>
            <Row gutter={[12, 12]}>
                <Col xs={24} md={8}>
                    <label className="block text-xs text-gray-500 mb-1">Эмч</label>
                    <Select
                        className="w-full"
                        value={filters.doctorId}
                        onChange={set("doctorId")}
                        options={doctors}
                        showSearch
                        optionFilterProp="label"
                    />
                </Col>
                <Col xs={24} md={8}>
                    <label className="block text-xs text-gray-500 mb-1">Техникч</label>
                    <Select
                        className="w-full"
                        value={filters.technicianId}
                        onChange={set("technicianId")}
                        options={technicians}
                        showSearch
                        optionFilterProp="label"
                    />
                </Col>
                <Col xs={24} md={8}>
                    <label className="block text-xs text-gray-500 mb-1">Ресейпшн</label>
                    <Select
                        className="w-full"
                        value={filters.receptionId}
                        onChange={set("receptionId")}
                        options={receptions}
                        showSearch
                        optionFilterProp="label"
                    />
                </Col>
            </Row>

            <Divider style={{ margin: "8px 0" }} orientation="left" plain>
                Үйлчлүүлэгч
            </Divider>
            <Row gutter={[12, 12]}>
                <Col xs={12} md={6}>
                    <label className="block text-xs text-gray-500 mb-1">Хүйс</label>
                    <Select
                        className="w-full"
                        value={filters.gender}
                        onChange={set("gender")}
                        options={[
                            { label: "Бүгд", value: -1 },
                            { label: "Эр", value: 1 },
                            { label: "Эм", value: 2 },
                        ]}
                    />
                </Col>
                <Col xs={6} md={4}>
                    <label className="block text-xs text-gray-500 mb-1">Нас )</label>
                    <InputNumber
                        className="w-full"
                        min={0}
                        max={120}
                        value={filters.ageFrom}
                        onChange={set("ageFrom")}
                    />
                </Col>
                <Col xs={6} md={4}>
                    <label className="block text-xs text-gray-500 mb-1">Нас (&lt;=)</label>
                    <InputNumber
                        className="w-full"
                        min={0}
                        max={120}
                        value={filters.ageTo}
                        onChange={set("ageTo")}
                    />
                </Col>
                <Col xs={24} md={10}>
                    <label className="block text-xs text-gray-500 mb-1">
                        Хариу авах утас
                    </label>
                    <Input
                        value={filters.answerPhone}
                        onChange={set("answerPhone")}
                        onPressEnter={onEnter}
                    />
                </Col>
            </Row>

            <Divider style={{ margin: "8px 0" }} orientation="left" plain>
                Бусад
            </Divider>
            <Row gutter={[12, 12]}>
                <Col xs={24} md={8}>
                    <label className="block text-xs text-gray-500 mb-1">
                        Тодосгогч бодис
                    </label>
                    <Select
                        className="w-full"
                        value={filters.ceitemid}
                        onChange={set("ceitemid")}
                        options={filteredCeItems}
                        showSearch
                        optionFilterProp="label"
                    />
                </Col>
                <Col xs={24} md={8}>
                    <label className="block text-xs text-gray-500 mb-1">Төлөв</label>
                    <Select
                        className="w-full"
                        value={filters.status}
                        onChange={set("status")}
                        options={[
                            { label: "Бүгд", value: -1 },
                            { label: "Идэвхтэй", value: 1 },
                            { label: "Дууссан", value: 0 },
                        ]}
                    />
                </Col>
                <Col xs={24} md={8}>
                    <label className="block text-xs text-gray-500 mb-1">
                        Нэмэлт тайлбар
                    </label>
                    <Input
                        value={filters.descr}
                        onChange={set("descr")}
                        onPressEnter={onEnter}
                    />
                </Col>

                <Col span={24}>
                    <Row gutter={[8, 8]}>
                        <Col>
                            <Checkbox
                                checked={filters.isCe == 1}
                                onChange={setBool("isCe")}
                            >
                                Тодосгогчтой
                            </Checkbox>
                        </Col>
                        <Col>
                            <Checkbox
                                checked={filters.isAns == 1}
                                onChange={setBool("isAns")}
                            >
                                Унтуулгатай
                            </Checkbox>
                        </Col>
                        <Col>
                            <Checkbox
                                checked={filters.urgent == 1}
                                onChange={setBool("urgent")}
                            >
                                Яаралтай
                            </Checkbox>
                        </Col>
                        <Col>
                            <Checkbox
                                checked={filters.isRepeat == 1}
                                onChange={setBool("isRepeat")}
                            >
                                Давтан
                            </Checkbox>
                        </Col>
                        <Col>
                            <Checkbox
                                checked={filters.insurance == 1}
                                onChange={setBool("insurance")}
                            >
                                ЭМД
                            </Checkbox>
                        </Col>
                        <Col>
                            <Checkbox
                                checked={filters.isEnglishResponse == 1}
                                onChange={setBool("isEnglishResponse")}
                            >
                                Англи хариу
                            </Checkbox>
                        </Col>
                        <Col>
                            <Checkbox
                                checked={filters.isBonus == 1}
                                onChange={setBool("isBonus")}
                            >
                                Bonus
                            </Checkbox>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    );

    return (
        <div>
            {mainFields}
            <Collapse
                ghost
                items={[
                    {
                        key: "extra",
                        label: (
                            <span className="text-xs text-blue-600">
                                Нэмэлт шүүлтүүр харах ▾
                            </span>
                        ),
                        children: extraFields,
                    },
                ]}
            />
        </div>
    );
}